/*
 OverlappingMarkerSpiderfier
https://github.com/jawj/OverlappingMarkerSpiderfier
Copyright (c) 2011 - 2017 George MacKerron
Released under the MIT licence: http://opensource.org/licenses/mit-license
Note: The Google Maps API v3 must be included *before* this code
*/
(function () {
	var v, y = {}.hasOwnProperty, z = [].slice;
	if (null == (null != (v = this.google) ? v.maps : void 0)) throw"Google Maps must be loaded already!";
	this.OverlappingMarkerSpiderfier = function () {
		function t(a, d) {
			var b, h;
			this.map = a;
			null == d && (d = {});
			for (b in d) y.call(d, b) && (h = d[b], this[b] = h);
			this.g = new this.constructor.l(this.map);
			this.F();
			this.c = {};
			this.h = this.m = null;
			g.addListener(this.map, "click", function (a) {
				return function () {
					return a.unspiderfy()
				}
			}(this));
			g.addListener(this.map, "maptypeid_changed", function (a) {
				return function () {
					return a.unspiderfy()
				}
			}(this));
			g.addListener(this.map, "zoom_changed", function (a) {
				return function () {
					a.unspiderfy();
					return a.i()
				}
			}(this))
		}

		var g, r, q, u, m, c, w, v;
		c = t.prototype;
		m = [t, c];
		q = 0;
		for (u = m.length; q < u; q++) v = m[q], v.VERSION = "0.4";
		t.markerStatus = {
			SPIDERFIED: "SPIDERFIED",
			SPIDERFIABLE: "SPIDERFIABLE",
			UNSPIDERFIABLE: "UNSPIDERFIABLE",
			REMOVED: "REMOVED"
		};
		r = google.maps;
		g = r.event;
		m = r.MapTypeId;
		w = 2 * Math.PI;
		c.keepSpiderfied = !1;
		c.markersWontHide = !1;
		c.markersWontMove = !1;
		c.nearbyDistance = 20;
		c.circleSpiralSwitchover = 9;
		c.circleFootSeparation = 23;
		c.circleStartAngle = w / 12;
		c.spiralFootSeparation = 26;
		c.spiralLengthStart = 11;
		c.spiralLengthFactor = 4;
		c.spiderfiedZIndex = r.Marker.MAX_ZINDEX + 1E8;
		c.highlightedLegZIndex = r.Marker.MAX_ZINDEX + 1E5;
		c.usualLegZIndex = r.Marker.MAX_ZINDEX + 100;
		c.legWeight = 1.5;
		c.legColors = {usual: {}, highlighted: {}};
		u = c.legColors.usual;
		q = c.legColors.highlighted;
		u[m.HYBRID] = u[m.SATELLITE] = "#fff";
		q[m.HYBRID] = q[m.SATELLITE] = "#f00";
		u[m.TERRAIN] = u[m.ROADMAP] = "#444";
		q[m.TERRAIN] = q[m.ROADMAP] = "#f00";
		c.setImmediate = function (a) {
			return window.setTimeout(a,
				0)
		};
		c.i = function () {
			if (null != this.formatMarkerWithStatus && null == this.m) return this.m = this.setImmediate(function (a) {
				return function () {
					a.m = null;
					return null != a.g.getProjection() ? a.C() : null != a.h ? void 0 : a.h = g.addListener(a.map, "idle", function () {
						a.h.remove();
						a.h = null;
						return a.C()
					})
				}
			}(this))
		};
		c.C = function () {
			var a, d, b, h, e, f, c;
			e = this.H();
			f = this.a;
			c = [];
			a = d = 0;
			for (b = f.length; d < b; a = ++d) h = f[a], a = e[a], a = a.b ? h._omsData ? "SPIDERFIED" : "SPIDERFIABLE" : "UNSPIDERFIABLE", c.push(this.formatMarkerWithStatus(h, this.constructor.markerStatus[a]));
			return c
		};
		c.F = function () {
			this.a = [];
			this.u = []
		};
		c.addMarker = function (a) {
			var d;
			if (null != a._oms) return this;
			a._oms = !0;
			d = [g.addListener(a, "click", function (b) {
				return function (d) {
					return b.U(a, d)
				}
			}(this))];
			this.markersWontHide || d.push(g.addListener(a, "visible_changed", function (b) {
				return function () {
					return b.G(a, !1)
				}
			}(this)));
			this.markersWontMove || d.push(g.addListener(a, "position_changed", function (b) {
				return function () {
					return b.G(a, !0)
				}
			}(this)));
			this.u.push(d);
			this.a.push(a);
			this.i();
			return this
		};
		c.G = function (a,
						d) {
			null == a._omsData || !d && a.getVisible() || null != this.v || null != this.A || this.unspiderfy(d ? a : null);
			if (null == this.v && null == this.A) return this.i()
		};
		c.getMarkers = function () {
			return this.a.slice(0)
		};
		c.removeMarker = function (a) {
			var d, b, h, e, f;
			null != a._omsData && this.unspiderfy();
			d = this.D(this.a, a);
			if (0 > d) return this;
			f = this.u.splice(d, 1)[0];
			b = 0;
			for (h = f.length; b < h; b++) e = f[b], g.removeListener(e);
			delete a._oms;
			this.a.splice(d, 1);
			"function" === typeof this.formatMarkerWithStatus && this.formatMarkerWithStatus(a, this.constructor.markerStatus.REMOVED);
			this.i();
			return this
		};
		c.clearMarkers = function () {
			var a, d, b, h, e, f, c, k;
			this.unspiderfy();
			k = this.a;
			a = d = 0;
			for (b = k.length; d < b; a = ++d) {
				f = k[a];
				e = this.u[a];
				c = 0;
				for (a = e.length; c < a; c++) h = e[c], g.removeListener(h);
				delete f._oms;
				"function" === typeof this.formatMarkerWithStatus && this.formatMarkerWithStatus(f, this.constructor.markerStatus.REMOVED)
			}
			this.F();
			return this
		};
		c.addListener = function (a, d) {
			var b;
			(null != (b = this.c)[a] ? b[a] : b[a] = []).push(d);
			return this
		};
		c.removeListener = function (a, d) {
			var b;
			b = this.D(this.c[a], d);
			0 > b || this.c[a].splice(b, 1);
			return this
		};
		c.clearListeners = function (a) {
			this.c[a] = [];
			return this
		};
		c.trigger = function () {
			var a, d, b, h, e, f;
			d = arguments[0];
			a = 2 <= arguments.length ? z.call(arguments, 1) : [];
			d = null != (b = this.c[d]) ? b : [];
			f = [];
			h = 0;
			for (e = d.length; h < e; h++) b = d[h], f.push(b.apply(null, a));
			return f
		};
		c.L = function (a, d) {
			var b, h, e, f, c;
			f = this.circleFootSeparation * (2 + a) / w;
			h = w / a;
			c = [];
			for (b = e = 0; 0 <= a ? e < a : e > a; b = 0 <= a ? ++e : --e) b = this.circleStartAngle + b * h, c.push(new r.Point(d.x + f * Math.cos(b), d.y + f * Math.sin(b)));
			return c
		};
		c.M = function (a, d) {
			var b, h, e, f, c;
			f = this.spiralLengthStart;
			b = 0;
			c = [];
			for (h = e = 0; 0 <= a ? e < a : e > a; h = 0 <= a ? ++e : --e) b += this.spiralFootSeparation / f + 5E-4 * h, h = new r.Point(d.x + f * Math.cos(b), d.y + f * Math.sin(b)), f += w * this.spiralLengthFactor / b, c.push(h);
			return c
		};
		c.U = function (a, d) {
			var b, h, e, c, n, k, l, x, g;
			(k = null != a._omsData) && this.keepSpiderfied || this.unspiderfy();
			if (k || this.map.getStreetView().getVisible() || "GoogleEarthAPI" === this.map.getMapTypeId()) return this.trigger("click", a, d);
			k = [];
			l = [];
			b = this.nearbyDistance;
			x = b *
				b;
			n = this.f(a.position);
			g = this.a;
			b = 0;
			for (h = g.length; b < h; b++) e = g[b], null != e.map && e.getVisible() && (c = this.f(e.position), this.j(c, n) < x ? k.push({
				P: e,
				I: c
			}) : l.push(e));
			return 1 === k.length ? this.trigger("click", a, d) : this.V(k, l)
		};
		c.markersNearMarker = function (a, d) {
			var b, c, e, f, n, k, l, g, m, p;
			null == d && (d = !1);
			if (null == this.g.getProjection()) throw"Must wait for 'idle' event on map before calling markersNearMarker";
			b = this.nearbyDistance;
			l = b * b;
			n = this.f(a.position);
			k = [];
			g = this.a;
			b = 0;
			for (c = g.length; b < c && !(e = g[b], e !== a &&
			null != e.map && e.getVisible() && (f = this.f(null != (m = null != (p = e._omsData) ? p.B : void 0) ? m : e.position), this.j(f, n) < l && (k.push(e), d))); b++) ;
			return k
		};
		c.H = function () {
			var a, d, b, c, e, f, n, k, l, g, m;
			if (null == this.g.getProjection()) throw"Must wait for 'idle' event on map before calling markersNearAnyOtherMarker";
			l = this.nearbyDistance;
			l *= l;
			var p;
			e = this.a;
			p = [];
			g = 0;
			for (d = e.length; g < d; g++) c = e[g], p.push({
				J: this.f(null != (a = null != (b = c._omsData) ? b.B : void 0) ? a : c.position),
				b: !1
			});
			g = this.a;
			a = b = 0;
			for (c = g.length; b < c; a = ++b) if (d =
					g[a], null != d.map && d.getVisible() && (f = p[a], !f.b)) for (m = this.a, d = k = 0, e = m.length; k < e; d = ++k) if (n = m[d], d !== a && null != n.map && n.getVisible() && (n = p[d], (!(d < a) || n.b) && this.j(f.J, n.J) < l)) {
				f.b = n.b = !0;
				break
			}
			return p
		};
		c.markersNearAnyOtherMarker = function () {
			var a, d, b, c, e, f, g;
			e = this.H;
			f = this.a;
			g = [];
			a = d = 0;
			for (b = f.length; d < b; a = ++d) c = f[a], e[a].b && g.push(c);
			return g
		};
		c.O = function (a) {
			return {
				o: function (d) {
					return function () {
						return a._omsData.s.setOptions({
							strokeColor: d.legColors.highlighted[d.map.mapTypeId],
							zIndex: d.highlightedLegZIndex
						})
					}
				}(this),
				w: function (d) {
					return function () {
						return a._omsData.s.setOptions({
							strokeColor: d.legColors.usual[d.map.mapTypeId],
							zIndex: d.usualLegZIndex
						})
					}
				}(this)
			}
		};
		c.V = function (a, d) {
			var b, c, e, f, n, k, l, m, q, p;
			this.v = !0;
			p = a.length;
			b = this.S(function () {
				var b, d, c;
				c = [];
				b = 0;
				for (d = a.length; b < d; b++) m = a[b], c.push(m.I);
				return c
			}());
			f = p >= this.circleSpiralSwitchover ? this.M(p, b).reverse() : this.L(p, b);
			b = function () {
				var b, d, h;
				h = [];
				b = 0;
				for (d = f.length; b < d; b++) e = f[b], c = this.T(e), q = this.R(a, function (a) {
					return function (b) {
						return a.j(b.I,
							e)
					}
				}(this)), l = q.P, k = new r.Polyline({
					map: this.map,
					path: [l.position, c],
					strokeColor: this.legColors.usual[this.map.mapTypeId],
					strokeWeight: this.legWeight,
					zIndex: this.usualLegZIndex
				}), l._omsData = {
					B: l.position,
					s: k
				}, this.legColors.highlighted[this.map.mapTypeId] !== this.legColors.usual[this.map.mapTypeId] && (n = this.O(l), l._omsData.N = {
					o: g.addListener(l, "mouseover", n.o),
					w: g.addListener(l, "mouseout", n.w)
				}), l.setPosition(c), l.setZIndex(Math.round(this.spiderfiedZIndex + e.y)), "function" === typeof this.formatMarkerWithStatus &&
				this.formatMarkerWithStatus(l, this.constructor.markerStatus.SPIDERFIED), h.push(l);
				return h
			}.call(this);
			delete this.v;
			this.K = !0;
			return this.trigger("spiderfy", b, d)
		};
		c.unspiderfy = function (a) {
			var d, b, c, e, f, n, k;
			null == a && (a = null);
			if (null == this.K) return this;
			this.A = !0;
			k = [];
			f = [];
			n = this.a;
			d = 0;
			for (b = n.length; d < b; d++) e = n[d], null != e._omsData ? (e._omsData.s.setMap(null), e !== a && e.setPosition(e._omsData.B), e.setZIndex(null), c = e._omsData.N, null != c && (g.removeListener(c.o), g.removeListener(c.w)), delete e._omsData,
			e !== a && "function" === typeof this.formatMarkerWithStatus && this.formatMarkerWithStatus(e, this.constructor.markerStatus.SPIDERFIABLE), k.push(e)) : f.push(e);
			delete this.A;
			delete this.K;
			this.trigger("unspiderfy", k, f);
			return this
		};
		c.j = function (a, d) {
			var b, c;
			b = a.x - d.x;
			c = a.y - d.y;
			return b * b + c * c
		};
		c.S = function (a) {
			var d, b, c, e, f;
			d = e = f = 0;
			for (b = a.length; d < b; d++) c = a[d], e += c.x, f += c.y;
			a = a.length;
			return new r.Point(e / a, f / a)
		};
		c.f = function (a) {
			return this.g.getProjection().fromLatLngToDivPixel(a)
		};
		c.T = function (a) {
			return this.g.getProjection().fromDivPixelToLatLng(a)
		};
		c.R = function (a, c) {
			var b, d, e, f, g, k;
			e = g = 0;
			for (k = a.length; g < k; e = ++g) if (f = a[e], f = c(f), "undefined" === typeof b || null === b || f < d) d = f, b = e;
			return a.splice(b, 1)[0]
		};
		c.D = function (a, c) {
			var b, d, e, f;
			if (null != a.indexOf) return a.indexOf(c);
			b = d = 0;
			for (e = a.length; d < e; b = ++d) if (f = a[b], f === c) return b;
			return -1
		};
		t.l = function (a) {
			return this.setMap(a)
		};
		t.l.prototype = new r.OverlayView;
		t.l.prototype.draw = function () {
		};
		return t
	}()
}).call(window);
/* Wed 25 Jan 2017 20:06:57 GMT */
